import {Col, Form, InputGroup} from "react-bootstrap";
import * as React from "react";
import {JSX, JSXElementConstructor} from "react";

interface Props {
  label: string,
  subLabel: string,
  step: number,
  value: number | undefined,
  placeholder: string,
  required: boolean,
  unit: JSX.Element,
  setValue: (valueToSet: number) => void,
}

function NumberField(props: Props) {
  return (
      <div className="form-row">
        <Col>
          <Form.Group className="form-element" controlId={props.label}>
            <Form.Label><small><b><span>{props.label}</span> {props.required && <span className={"font-red"}>*</span>}</b></small></Form.Label>
              <InputGroup>
                <InputGroup.Text>{props.unit}</InputGroup.Text>
                <Form.Control
                    type="number"
                    name={props.label}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={(e) => props.setValue(+e.target.value)}
                    step={props.step}
                    required={props.required}
                />
              </InputGroup>
            <Form.Text className="text-muted">
              {props.subLabel}
            </Form.Text>
          </Form.Group>
        </Col>
      </div>
  )
}

export default NumberField;